<div class="gap-10">
  <h2>{{ data.header }}</h2>
  <p>{{ data.body }}</p>
</div>
<div class="flex gap-16">
  <app-button (click)="confirm($event)">
    {{ data.leftButton }}
  </app-button>
  <app-button buttonType="outline" (click)="close($event)">
    {{ data.rightButton }}
  </app-button>
</div>
